import { app_login_principal_RowClass, app_mst_grp_hdr_RowClass, app_mst_link_grp_to_role_RowClass, app_mst_link_subject_to_role_RowClass, app_mst_role_RowClass, app_perm_set_hdr_RowClass, app_perm_set_line_RowClass, app_perm_template_hdr_RowClass } from "blg-akaun-ts-lib";

export class RoleModel {
    app_mst_role: app_mst_role_RowClass = new app_mst_role_RowClass();
    num_users: number;
    num_teams: number;
    created_by_name: string;
    updated_by_name: string;
}

export class UserRoleModel {
    app_mst_link_subject_to_role: app_mst_link_subject_to_role_RowClass = new app_mst_link_subject_to_role_RowClass();
    app_login_principal_email: app_login_principal_RowClass = new app_login_principal_RowClass();
    app_login_principal_mobile: app_login_principal_RowClass = new app_login_principal_RowClass();
}

export class TeamRoleModel {
    app_mst_link_grp_to_role: app_mst_link_grp_to_role_RowClass = new app_mst_link_grp_to_role_RowClass();
    app_mst_grp_hdr: app_mst_grp_hdr_RowClass = new app_mst_grp_hdr_RowClass();
    num_members: number;
}

export class RolePermSetModel {
    app_perm_set_hdr: app_perm_set_hdr_RowClass = new app_perm_set_hdr_RowClass();
    app_perm_set_lines: app_perm_set_line_RowClass[] = [];
    app_perm_template_hdr: app_perm_template_hdr_RowClass = new app_perm_template_hdr_RowClass();
}

export interface RoleForm {
    name: string;
    code: string;
    currStatus: string;
    status: string;
}

export interface RoleDetailsForm {
    name: string;
    description: string;
    currStatus: string;
    status: string;
    code: string;
    createdDate: string;
    updatedDate: string;
    createdBy: string;
    updatedBy: string;
}